import { CachedCatalogEntry, SupportedLocale } from './types';

const CATALOG_CACHE_PREFIX = 'gym_planner_i18n_catalog';

function getCatalogStorageKey(locale: SupportedLocale): string {
  return `${CATALOG_CACHE_PREFIX}_${locale}`;
}

export function loadCachedCatalog(locale: SupportedLocale): CachedCatalogEntry | null {
  try {
    const raw = localStorage.getItem(getCatalogStorageKey(locale));
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as CachedCatalogEntry;
    if (!parsed.locale || !parsed.version || !parsed.etag || !parsed.namespaces) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function saveCachedCatalog(entry: CachedCatalogEntry): void {
  try {
    localStorage.setItem(getCatalogStorageKey(entry.locale), JSON.stringify(entry));
  } catch {
    // Ignore storage errors in private mode/quota pressure.
  }
}
